import {truncate} from 'lodash';

function truncateText(text: string, length: number) {
  return truncate(text, {length});
}

export default truncateText;
